import { render, staticRenderFns } from "./OrdersReport.vue?vue&type=template&id=271f797e&scoped=true&"
import script from "./OrdersReport.vue?vue&type=script&lang=js&"
export * from "./OrdersReport.vue?vue&type=script&lang=js&"
import style0 from "./OrdersReport.vue?vue&type=style&index=0&id=271f797e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271f797e",
  null
  
)

export default component.exports